"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralsModule = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var data_processing_service_1 = require("../services/data-processing.service");
var ReferralsModule = /** @class */ (function () {
    function ReferralsModule() {
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    ReferralsModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _ActionMapping;
            var _this = this;
            return __generator(this, function (_a) {
                if (customer) {
                    this.dataProcessing.fillDataGet(moduleDiv, customer);
                    _ActionMapping = {
                        copy: function () { return _this.copyReferralCode(customer.referralCode); },
                        share: function () { return _this.shareReferralData(customer.referralCode); },
                    };
                    this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                }
                else {
                    // TODO error handling
                }
                return [2 /*return*/];
            });
        });
    };
    ReferralsModule.prototype.copyReferralCode = function (code) {
        navigator.clipboard.writeText(code).then(function () {
            console.log('Text successfully copied to clipboard');
        }, function (err) {
            console.error('Error in copying text: ', err);
        });
    };
    ReferralsModule.prototype.shareReferralData = function (code) {
        if (navigator.share) {
            navigator
                .share({
                title: "".concat(this.config.get.tenantKey, " referral"),
                text: translation_1.default.t('Want to come train with me at') +
                    this.config.get.tenantKey +
                    '?' +
                    translation_1.default.t('Use my referral code') +
                    code +
                    translation_1.default.t('to register!') +
                    '\nhttps://technogym-sso-testing.webflow.io/referal', // TODO change url
            })
                .then(function () { return console.log('Share was successful.'); })
                .catch(function (error) { return console.log('Sharing failed', error); });
        }
        else {
            console.log('Web Share API is not supported in your browser.');
        }
    };
    return ReferralsModule;
}());
exports.ReferralsModule = ReferralsModule;
